export default theme => {
  return {
    root: {
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      whiteSpace: 'nowrap'
    }
  };
};
